import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

/**
 * Upload a document for validation
 * @param {File} file - The file to upload
 * @returns {Promise} Response with document ID
 */
export const uploadDocument = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(`${API_BASE_URL}/DocumentUpload`, formData, {
      headers: {
    'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error uploading document:', error);
    throw new Error(error.response?.data?.message || 'Failed to upload document');
  }
};

/**
 * Validate a document by ID
 * @param {string} documentId - The ID of the document to validate
 * @returns {Promise} Validation results
 */
export const validateDocument = async (documentId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/DocumentValidation`, {
      params: { documentId },
    });

    return response.data;
  } catch (error) {
    console.error('Error validating document:', error);
    // Pass through the full error object so ValidatorPage can access error.response.data
    const err = new Error(error.response?.data?.message || 'Failed to validate document');
    err.response = error.response;
    throw err;
  }
};

/**
 * Get validation history (prepared for future use with authentication)
 * @returns {Promise} List of previous validations
 */
export const getValidationHistory = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/ValidationHistory`);
    return response.data;
  } catch (error) {
    console.error('Error fetching validation history:', error);
    throw new Error(error.response?.data?.message || 'Failed to fetch validation history');
  }
};

// Prepared for future authentication integration
/**
 * Login user (placeholder for Azure AD B2C integration)
 * @param {Object} credentials - User credentials
 * @returns {Promise} Authentication response
 */
export const login = async (credentials) => {
  // TODO: Implement Azure AD B2C authentication
  throw new Error('Authentication not yet implemented');
};

/**
 * Logout user (placeholder for Azure AD B2C integration)
 * @returns {Promise} Logout response
 */
export const logout = async () => {
  // TODO: Implement Azure AD B2C logout
  throw new Error('Authentication not yet implemented');
};
